import React, { useEffect, useRef, useState  } from "react";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import "./scroll.css";
// import "../Responsive.css";
// import "../Components/OverlayVideoSection.css";

// import "../Tab.css";
// import "normalize.css"
// import handson from "../../../src/assets/images/handson.svg";

// import scope from "/src/assets/images/scope.svg";
// import scan from "/src/assets/images/scan.svg";
// import bulb from "/src/assets/images/bulb.svg";


const HandsOn = () => {
  const triggerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);


  const textRef = useRef();
    // Intersection Observer for fade-in text
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting); // Set visibility based on intersection
        },
        {
          threshold: 0.5, // Trigger when 50% of the element is visible
        }
      );
  
      const textElement = textRef.current;
      if (textElement) observer.observe(textElement);
  
      return () => {
        if (textElement) observer.unobserve(textElement);
      };
    }, []);

 useEffect(() => {
            // Ensure Typeform embed script is loaded
            const script = document.createElement('script');
            script.src = '//embed.typeform.com/next/embed.js';
            script.async = true;
            document.body.appendChild(script);
        
            return () => {
              document.body.removeChild(script);
            };
          }, []);

  return (
    <section className="check_list"  style={{backgroundColor:"rgb(7, 26, 40)"}}>
      <div className="container">
        <div className="byb-checklist-header" ref={triggerRef}>
          <p ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}`}
              >WORKSHOPS</p>
          <h2>
            <span className="d-lg-block ">Hands-On Interactive Sessions </span>
          </h2>
        </div>
              <p className="text-center para_p p_txt">
              Dive into workshops covering each stage of 4D Process.  Tackle live challenges, learn something new, and leave with fresh perspectives.  
                    </p>

                    <div className="hide_btn">
                      <div data-tf-live="01JJV14J257ED52SCENJ77441Y" className="text-center position-relative   "></div>
                    </div>
                    <button  className="blue_btn join_btn overlap_btn">Explore Workshops</button>

          
                   <div className="whats_app text-center">
                    <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/handson.svg" alt="Hands-on brand workshop visual" className="center_img" />
                   </div>
        
       
      </div>
    </section>
  );
};

export default HandsOn;
